import v from "./ghl-ui.es795.js";
import y from "./ghl-ui.es372.js";
import L from "./ghl-ui.es796.js";
import O from "./ghl-ui.es797.js";
import D from "./ghl-ui.es798.js";
import N from "./ghl-ui.es799.js";
import F from "./ghl-ui.es800.js";
import P from "./ghl-ui.es364.js";
import "./ghl-ui.es363.js";
import { DraggableInitializedEvent as w, DraggableDestroyEvent as x } from "./ghl-ui.es371.js";
import { DragStartEvent as T, DragMoveEvent as M, DragOutEvent as A, DragOutContainerEvent as U, DragOverContainerEvent as I, DragOverEvent as z, DragStopEvent as B, DragStoppedEvent as H, DragPressureEvent as j } from "./ghl-ui.es370.js";
const g = Symbol("onDragStart"), l = Symbol("onDragMove"), u = Symbol("onDragStop"), h = Symbol("onDragPressure"), d = Symbol("dragStop"), k = {
  "drag:start": (i) => `Picked up ${i.source.textContent.trim() || i.source.id || "draggable element"}`,
  "drag:stop": (i) => `Released ${i.source.textContent.trim() || i.source.id || "draggable element"}`
}, q = {
  "container:dragging": "draggable-container--is-dragging",
  "source:dragging": "draggable-source--is-dragging",
  "source:placed": "draggable-source--placed",
  "container:placed": "draggable-container--placed",
  "body:dragging": "draggable--is-dragging",
  "draggable:over": "draggable--over",
  "container:over": "draggable-container--over",
  "source:original": "draggable--original",
  mirror: "draggable-mirror"
}, $ = {
  draggable: ".draggable-source",
  handle: null,
  delay: {},
  distance: 0,
  placedTimeout: 800,
  plugins: [],
  sensors: [],
  exclude: {
    plugins: [],
    sensors: []
  }
};
class m {
  constructor(r = [document.body], e = {}) {
    if (r instanceof NodeList || r instanceof Array)
      this.containers = [...r];
    else if (r instanceof HTMLElement)
      this.containers = [r];
    else
      throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
    this.options = {
      ...$,
      ...e,
      classes: {
        ...q,
        ...e.classes || {}
      },
      announcements: {
        ...k,
        ...e.announcements || {}
      },
      exclude: {
        plugins: e.exclude && e.exclude.plugins || [],
        sensors: e.exclude && e.exclude.sensors || []
      }
    }, this.emitter = new N(), this.dragging = !1, this.plugins = [], this.sensors = [], this[g] = this[g].bind(this), this[l] = this[l].bind(this), this[u] = this[u].bind(this), this[h] = this[h].bind(this), this[d] = this[d].bind(this), document.addEventListener("drag:start", this[g], !0), document.addEventListener("drag:move", this[l], !0), document.addEventListener("drag:stop", this[u], !0), document.addEventListener("drag:pressure", this[h], !0);
    const t = Object.values(m.Plugins).filter((n) => !this.options.exclude.plugins.includes(n)), s = Object.values(m.Sensors).filter((n) => !this.options.exclude.sensors.includes(n));
    this.addPlugin(...t, ...this.options.plugins), this.addSensor(...s, ...this.options.sensors);
    const c = new w({
      draggable: this
    });
    this.on("mirror:created", ({
      mirror: n
    }) => this.mirror = n), this.on("mirror:destroy", () => this.mirror = null), this.trigger(c);
  }
  destroy() {
    document.removeEventListener("drag:start", this[g], !0), document.removeEventListener("drag:move", this[l], !0), document.removeEventListener("drag:stop", this[u], !0), document.removeEventListener("drag:pressure", this[h], !0);
    const r = new x({
      draggable: this
    });
    this.trigger(r), this.removePlugin(...this.plugins.map((e) => e.constructor)), this.removeSensor(...this.sensors.map((e) => e.constructor));
  }
  addPlugin(...r) {
    const e = r.map((t) => new t(this));
    return e.forEach((t) => t.attach()), this.plugins = [...this.plugins, ...e], this;
  }
  removePlugin(...r) {
    return this.plugins.filter((t) => r.includes(t.constructor)).forEach((t) => t.detach()), this.plugins = this.plugins.filter((t) => !r.includes(t.constructor)), this;
  }
  addSensor(...r) {
    const e = r.map((t) => new t(this.containers, this.options));
    return e.forEach((t) => t.attach()), this.sensors = [...this.sensors, ...e], this;
  }
  removeSensor(...r) {
    return this.sensors.filter((t) => r.includes(t.constructor)).forEach((t) => t.detach()), this.sensors = this.sensors.filter((t) => !r.includes(t.constructor)), this;
  }
  addContainer(...r) {
    return this.containers = [...this.containers, ...r], this.sensors.forEach((e) => e.addContainer(...r)), this;
  }
  removeContainer(...r) {
    return this.containers = this.containers.filter((e) => !r.includes(e)), this.sensors.forEach((e) => e.removeContainer(...r)), this;
  }
  on(r, ...e) {
    return this.emitter.on(r, ...e), this;
  }
  off(r, e) {
    return this.emitter.off(r, e), this;
  }
  trigger(r) {
    return this.emitter.trigger(r), this;
  }
  getClassNameFor(r) {
    return this.getClassNamesFor(r)[0];
  }
  getClassNamesFor(r) {
    const e = this.options.classes[r];
    return e instanceof Array ? e : typeof e == "string" || e instanceof String ? [e] : [];
  }
  isDragging() {
    return !!this.dragging;
  }
  getDraggableElements() {
    return this.containers.reduce((r, e) => [...r, ...this.getDraggableElementsForContainer(e)], []);
  }
  getDraggableElementsForContainer(r) {
    return [...r.querySelectorAll(this.options.draggable)].filter((t) => t !== this.originalSource && t !== this.mirror);
  }
  cancel() {
    this[d]();
  }
  [g](r) {
    const e = S(r), {
      target: t,
      container: s,
      originalSource: c
    } = e;
    if (!this.containers.includes(s))
      return;
    if (this.options.handle && t && !v(t, this.options.handle)) {
      e.cancel();
      return;
    }
    this.originalSource = c, this.sourceContainer = s, this.lastPlacedSource && this.lastPlacedContainer && (clearTimeout(this.placedTimeoutID), this.lastPlacedSource.classList.remove(...this.getClassNamesFor("source:placed")), this.lastPlacedContainer.classList.remove(...this.getClassNamesFor("container:placed"))), this.source = this.originalSource.cloneNode(!0), this.originalSource.parentNode.insertBefore(this.source, this.originalSource), this.originalSource.style.display = "none";
    const n = new T({
      source: this.source,
      originalSource: this.originalSource,
      sourceContainer: s,
      sensorEvent: e
    });
    if (this.trigger(n), this.dragging = !n.canceled(), n.canceled()) {
      this.source.remove(), this.originalSource.style.display = null;
      return;
    }
    this.originalSource.classList.add(...this.getClassNamesFor("source:original")), this.source.classList.add(...this.getClassNamesFor("source:dragging")), this.sourceContainer.classList.add(...this.getClassNamesFor("container:dragging")), document.body.classList.add(...this.getClassNamesFor("body:dragging")), C(document.body, "none"), requestAnimationFrame(() => {
      const p = S(r).clone({
        target: this.source
      });
      this[l]({
        ...r,
        detail: p
      });
    });
  }
  [l](r) {
    if (!this.dragging)
      return;
    const e = S(r), {
      container: t
    } = e;
    let s = e.target;
    const c = new M({
      source: this.source,
      originalSource: this.originalSource,
      sourceContainer: t,
      sensorEvent: e
    });
    this.trigger(c), c.canceled() && e.cancel(), s = v(s, this.options.draggable);
    const n = v(e.target, this.containers), o = e.overContainer || n, p = this.currentOverContainer && o !== this.currentOverContainer, f = this.currentOver && s !== this.currentOver, b = o && this.currentOverContainer !== o, E = n && s && this.currentOver !== s;
    if (f) {
      const a = new A({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t,
        sensorEvent: e,
        over: this.currentOver,
        overContainer: this.currentOverContainer
      });
      this.currentOver.classList.remove(...this.getClassNamesFor("draggable:over")), this.currentOver = null, this.trigger(a);
    }
    if (p) {
      const a = new U({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t,
        sensorEvent: e,
        overContainer: this.currentOverContainer
      });
      this.currentOverContainer.classList.remove(...this.getClassNamesFor("container:over")), this.currentOverContainer = null, this.trigger(a);
    }
    if (b) {
      o.classList.add(...this.getClassNamesFor("container:over"));
      const a = new I({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t,
        sensorEvent: e,
        overContainer: o
      });
      this.currentOverContainer = o, this.trigger(a);
    }
    if (E) {
      s.classList.add(...this.getClassNamesFor("draggable:over"));
      const a = new z({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t,
        sensorEvent: e,
        overContainer: o,
        over: s
      });
      this.currentOver = s, this.trigger(a);
    }
  }
  [d](r) {
    if (!this.dragging)
      return;
    this.dragging = !1;
    const e = new B({
      source: this.source,
      originalSource: this.originalSource,
      sensorEvent: r ? r.sensorEvent : null,
      sourceContainer: this.sourceContainer
    });
    this.trigger(e), e.canceled() || this.source.parentNode.insertBefore(this.originalSource, this.source), this.source.remove(), this.originalSource.style.display = "", this.source.classList.remove(...this.getClassNamesFor("source:dragging")), this.originalSource.classList.remove(...this.getClassNamesFor("source:original")), this.originalSource.classList.add(...this.getClassNamesFor("source:placed")), this.sourceContainer.classList.add(...this.getClassNamesFor("container:placed")), this.sourceContainer.classList.remove(...this.getClassNamesFor("container:dragging")), document.body.classList.remove(...this.getClassNamesFor("body:dragging")), C(document.body, ""), this.currentOver && this.currentOver.classList.remove(...this.getClassNamesFor("draggable:over")), this.currentOverContainer && this.currentOverContainer.classList.remove(...this.getClassNamesFor("container:over")), this.lastPlacedSource = this.originalSource, this.lastPlacedContainer = this.sourceContainer, this.placedTimeoutID = setTimeout(() => {
      this.lastPlacedSource && this.lastPlacedSource.classList.remove(...this.getClassNamesFor("source:placed")), this.lastPlacedContainer && this.lastPlacedContainer.classList.remove(...this.getClassNamesFor("container:placed")), this.lastPlacedSource = null, this.lastPlacedContainer = null;
    }, this.options.placedTimeout);
    const t = new H({
      source: this.source,
      originalSource: this.originalSource,
      sensorEvent: r ? r.sensorEvent : null,
      sourceContainer: this.sourceContainer
    });
    this.trigger(t), this.source = null, this.originalSource = null, this.currentOverContainer = null, this.currentOver = null, this.sourceContainer = null;
  }
  [u](r) {
    this[d](r);
  }
  [h](r) {
    if (!this.dragging)
      return;
    const e = S(r), t = this.source || v(e.originalEvent.target, this.options.draggable), s = new j({
      sensorEvent: e,
      source: t,
      pressure: e.pressure
    });
    this.trigger(s);
  }
}
m.Plugins = {
  Announcement: y,
  Focusable: L,
  Mirror: O,
  Scrollable: D
};
m.Sensors = {
  MouseSensor: F,
  TouchSensor: P
};
function S(i) {
  return i.detail;
}
function C(i, r) {
  i.style.webkitUserSelect = r, i.style.mozUserSelect = r, i.style.msUserSelect = r, i.style.oUserSelect = r, i.style.userSelect = r;
}
export {
  m as default,
  $ as defaultOptions
};
